import { IEFileAnalyzerCarriers } from "../models";
import { CarrierTypeEnum, EFileAnalyzerTypeEnum } from "./enum";
import { Color } from '@material-ui/lab/Alert';

export const contentDispositionHeader: string = 'Content-Disposition';
export const carriers : IEFileAnalyzerCarriers[] = [
	{
		type: CarrierTypeEnum.USPS,
		analyzers: [EFileAnalyzerTypeEnum.SSF, EFileAnalyzerTypeEnum.PSE],
	},
	{
		type: CarrierTypeEnum.UPS,
		analyzers: [EFileAnalyzerTypeEnum.PLD],
	},
];

export const unitDisplayMapping = {
    m: "Metre (m)",
    cm: "Centimetre (cm)",
    ft: "Foot (ft)",
    in: "Inch (in)",
	yd: "Yard (yd)",
    g: "Gram (g)",
    kg: "Kilogram (kg)",
    mg: "Milligram (mg)",
    lb: "Pound (lb)",
    oz: "Ounce (oz)",
	cmsquare: "Square Centimetre (cm²)",
    msquare: "Square Metre (m²)",
    insquare: "Square Inch (in²)",
    ftsquare: "Square Foot (ft²)",
    ydsquare: "Square Yard (yd²)",
    cmcube: "Cubic Centimetre (cm³)",
    mcube: "Cubic Metre (m³)",
    incube: "Cubic Inch (in)³",
    ftcube: "Cubic Foot (ft³)",
    ydcube: "Cubic Yard (yd³)",
    liter: "Liter"
  }

export const Constant = {
	storageCodeVerifier : 'codeVerifier',
	defaultCountryCode: 'IN',
	colorWarning: 'warning' as Color,
	colorInfo: 'info' as Color,
	colorSuccess: 'success' as Color,
	colorError: 'error' as Color,
	na: "N/A"
}

export const Placeholder = {
	productId: "{productId}",
	grantType: "{grantType}",
	redirectUri: "{redirectUri}",
	state: "{state}",
	codeChallenge: "{codeChallenge}"
}

export const clientRoutes = {
	signIn: '/signin',
	signUp: '/signup',
	dashboard: '/dashboard',
	efileAnalyzer: '/efile-analyzer',
	realSizeViewer: '/realsize-viewer', 
	geocoder: '/geocoder',
	unitConverter: '/unit-converter',
	volumetricWeight: '/volumetric-weight'
}


export const drawerWidth = 250;